import { render, staticRenderFns } from "./LineDoubleStack.vue?vue&type=template&id=831d8d70&"
import script from "./LineDoubleStack.vue?vue&type=script&lang=js&"
export * from "./LineDoubleStack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports